import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ResourceMainGroupEditor.html?raw';
import lang from 'dojo/_base/lang';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import Edit from '../../../moreCore/UI/Edit/Edit';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import { PhysicalResourcesEditor } from "../MainCatalogEditorTools";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

interface ResourceEntry {
    ID: string;
    code: string;
    description: string;
//    isDeleted?: boolean;
//    isNew?: boolean;
}
class ResourceMainGroupEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private input_Description: MdsLax<InstanceType<typeof Edit>>;
    private input_Code: MdsLax<InstanceType<typeof Edit>>;

    private expanderResources: MdsLax<InstanceType<typeof ExpandableSection>>;
    private selectedResources: Array<ResourceEntry> = [];
    private resourcesTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private resourcesTableContainer: HTMLElement;

    isValid(): boolean {
        if (!this.input_Code.isValid) return false;
        if (!this.input_Description.isValid) return false;
        return true;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);
        
        this.selectedResources = lang.clone(this.getAttributeValue("resources"));
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ResourceMainGroup;
    }

    private _setUpTable(response: { layouts: Array<any> }) {

        if (this.resourcesTable != null) this.resourcesTable.destroy();

        this.resourcesTable = new StaticTable();
        this.resourcesTable.placeAt(this.resourcesTableContainer);

        this.resourcesTable.setLayout(response.layouts[0]);

        this.resourcesTable.setRowClick(lang.hitch(this, this._onRowClick))

        this.updateTable();
    }

    private _onRowClick(row: StaticTable.StaticTableRow<ResourceEntry>) {

        this.requestNewPhysicalResourcesEditor(row.rowGroup.entity, row.rowGroup.displayname)
    }
    private requestNewPhysicalResourcesEditor(entity?: any, displayname?: string) {

        let entityId = null;
        let form = null;
        if (entity) {
            try {
                entityId = entity.ID;
            } catch (ex) {
                alert("no ID-Property set for clicked entity!");
                return;
            }

        }

        if (!displayname) {
            displayname = this.translate("General_Loading");
        }

        let newLabel = this.translate("General_CreateNew") + " - " + this.translate("General_Label_TodoDescription");
        form = new PhysicalResourcesEditor();

        if (this.isEmbeddedInTab) {
            this.requestNewTabbedContent({
                enableClosing: true,
                label: entityId ? displayname : newLabel,
                sidebarEntryName: entityId ? entityId : "new-" + MainCatalogs_Classes.PhysicalResources,
                name: entityId ? entityId : "_blank",
                widget: form,
                coloration: this.tabColor,
                groupLabel: displayname
            }, true);
        } else {
            //Show dlg
            var dlg = new GenericDialog();

        }

        if (entityId) {
            form.loadEntity(entityId);
        } else {
            form.updateHeading(newLabel);
            form.setStartupState("ready");
        }
    }
    private updateTable() {

        let selectedResources: Array<ResourceEntry> = lang.clone(this.getAttributeValue("resources"));

        selectedResources?.length > 0 ? this.expanderResources.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderResources.setMarking(ExpandableSectionMarkings.default);

        this.resourcesTable.setData(selectedResources);

    //    selectedResources?.forEach(s => {
    //        if (s.isDeleted === true) {
    //            this.disableNode(this.resourcesTable.getRowGroupByKeyValue(s.assignmentID, "assignmentID").rows[0].node);
    //        }
    //    })
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetResourcesTable",
            null,
            lang.hitch(this, this._setUpTable),
            (err) => { this.showToast(err.Message) }
        )
    }
}

export default mdsWidget(ResourceMainGroupEditor);